import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.313 2.5c-.47 0-3.75.938-3.75 5.156v3.282c0 1.034.84 1.874 1.874 1.874h.938v3.75a.936.936 0 1 0 1.875 0V3.439a.936.936 0 0 0-.937-.938M5 2.969c0-.24-.179-.44-.419-.466a.466.466 0 0 0-.507.363L3.187 6.86a2.58 2.58 0 0 0 2.282 3.13v6.573a.936.936 0 1 0 1.875 0V9.989A2.58 2.58 0 0 0 9.626 6.86l-.888-3.993a.469.469 0 0 0-.925.103V6.9a.288.288 0 0 1-.575.024l-.366-3.996a.466.466 0 0 0-.466-.428.466.466 0 0 0-.466.428l-.363 3.996a.288.288 0 0 1-.574-.023V2.968zm1.415 4.453h-.018l.01-.02z"
    }, null, -1)
  ]))]))
}
export default { render: render }